import {Diy4Install} from "../../features/diy/Diy4Installation"

export default Diy4Install.Page
